import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './DropdownIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const DropdownIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function DropdownIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 12 7" component={Icon} {...props} />
  );
});
